<template>
  <v-card class="pa-0 ma-0 restion-store__sticky-header rounded-0"
          :height="height"
          :dark="dark"
          :color="color"
          :elevation="elevation"
          :style="styles"
  >
    <v-container v-if="enabled" class="d-flex flex-row py-0">
      <NavigationButton :dark="dark" position="top-left" />
      <NavigationFab position="top-left-fab" class="mt-2" />
      <Breadcrumbs :items="breadcrumbs" class="flex-grow-1 ml-2" />
      <v-spacer />
      <NavigationButton :dark="dark" position="top-right" />
      <NavigationFab position="top-right-fab" class="mt-2" />
    </v-container>
    <v-container v-else-if="stickySection" class="d-flex flex-row py-0" >
      <NavigationButton :dark="dark" position="top-left" />
      <NavigationFab position="top-left-fab" class="mt-2" />
      <v-spacer />
      <NavigationButton :dark="dark" position="top-right" />
      <NavigationFab position="top-right-fab" class="mt-2" />
    </v-container>
    <v-container v-else >
      <NavigationFab position="top-left-fab" position-alt="top-left" class="mt-2" />
      <v-spacer />
      <NavigationFab position="top-right-fab" position-alt="top-right" class="mt-2" />
    </v-container>

  </v-card>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs';
import NavigationButton from '@/components/NavigationButton';
import NavigationFab from '@/components/NavigationFab';

export default {
  name: 'StickyHeader',
  components: { NavigationFab, NavigationButton, Breadcrumbs },
  computed: {
    section() {
      const { section } = this.$store.state.ui;
      return this.$store.state.data.sections.find(({ id }) => id === section) || {};
    },
    enabled() {
      return this.$store.state.theme.stickyHeader;
    },
    stickySection() {
      return this.$store.state.theme.stickySection;
    },
    height() {
      if (!this.enabled) return 0;
      return this.$store.state.theme.stickyHeaderHeight;
    },
    dark() {
      return this.$store.state.theme.stickyHeaderDark;
    },
    color() {
      return this.$store.state.theme.stickyHeaderColor;
    },
    elevation() {
      return this.$store.state.theme.stickyHeaderElevation;
    },
    breadcrumbs() {
      const { path } = this.section;
      if (!path) return [];
      return path.map((item) => ({ text: item.text, id: item.id }));
    },
    styles() {
      return {
        lineHeight: `${this.height * 0.95}px`,
        top: `${this.stickyTop}px`
      };
    },
    stickyTop() {
      let out = 0;
      out += this.$store.state.ui.headerHeight;
      return out;
    },
  },
};
</script>
